import { IIconProps } from "@/components/icons/interface";
import { useTheme } from "@/contexts/theme";
import { HpPDFIcon } from "@/themes/hp-client/icons/HpPDFIcon";

const PDFIcon = ({ width, height, color }: IIconProps) => {
  const strokeColor = color || "var(--theme-secondary-300, #8283BE)";
  const { currentTheme } = useTheme();
  const isHpClient = currentTheme === "hp-client";
  if (isHpClient) return <HpPDFIcon width={20} height={20} />;
  else
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || "20"}
        height={height || "20"}
        fill={strokeColor}
        viewBox="0 0 256 256"
      >
        <path d="M224,152a8,8,0,0,1-8,8H192v16h16a8,8,0,0,1,0,16H192v16a8,8,0,0,1-16,0V152a8,8,0,0,1,8-8h32A8,8,0,0,1,224,152ZM92,172a28,28,0,0,1-28,28H56v8a8,8,0,0,1-16,0V152a8,8,0,0,1,8-8H64A28,28,0,0,1,92,172Zm-16,0a12,12,0,0,0-12-12H56v24h8A12,12,0,0,0,76,172Zm88,8a36,36,0,0,1-36,36H112a8,8,0,0,1-8-8V152a8,8,0,0,1,8-8h16A36,36,0,0,1,164,180Zm-16,0a20,20,0,0,0-20-20h-8v40h8A20,20,0,0,0,148,180ZM40,112V40A16,16,0,0,1,56,24h96a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88v24a8,8,0,0,1-16,0V96H152a8,8,0,0,1-8-8V40H56v72a8,8,0,0,1-16,0ZM160,80h28.69L160,51.31Z"></path>
      </svg>
    );
};

export { PDFIcon };
